var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "item",
      class: {
        item2: _vm.type != 1,
        item3: _vm.type == 7,
        item8: _vm.type == 8,
      },
      on: {
        click: function ($event) {
          return _vm.lookDetails(_vm.item)
        },
      },
    },
    [
      _vm.type == 1
        ? _c("div", { staticClass: "img" }, [
            _c("img", {
              attrs: {
                src:
                  _vm.fileUrl(_vm.item.previewPic) || _vm.$store.getters.noImg,
              },
            }),
            _vm._v(" "),
            _vm.clickMode !== "course"
              ? _c("div", { staticClass: "course-count" }, [
                  _vm._v("课程 " + _vm._s(_vm.item.courseCount || 0)),
                ])
              : _vm._e(),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.type != 1
        ? _c("div", { staticClass: "img2" }, [
            _c("img", {
              attrs: {
                src:
                  _vm.fileUrl(_vm.item.courseImage) || _vm.$store.getters.noImg,
              },
            }),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "mainText" }, [
        _c("div", { staticClass: "tit" }, [_vm._v(_vm._s(_vm.item.name))]),
        _vm._v(" "),
        _c("div", { staticClass: "sourse " }, [
          _c("img", {
            attrs: { src: require("../assets/img/image/list1.png") },
          }),
          _vm._v(" "),
          _c("div", { staticClass: "text_w" }, [
            _vm._v(
              " " +
                _vm._s(
                  _vm.item.emceeCompanyname ? _vm.item.emceeCompanyname : "---"
                )
            ),
          ]),
        ]),
        _vm._v(" "),
        _vm.type == 1 || _vm.type == 8
          ? _c("div", [
              _vm.type == 8
                ? _c("div", { staticClass: "sourse" }, [
                    _c("div", { staticClass: "text_w" }, [
                      _vm._v(
                        _vm._s(_vm.item.hostTeacher ? _vm.item.hostTeacher : "")
                      ),
                    ]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "sourse" }, [
                _c("img", {
                  attrs: { src: require("../assets/img/image/list2.png") },
                }),
                _vm._v(" "),
                _c("div", { staticClass: "text_w" }, [
                  _vm._v(_vm._s(_vm.item.industry ? _vm.item.industry : "---")),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "sourse" }, [
                _c("img", {
                  attrs: { src: require("../assets/img/image/list3.png") },
                }),
                _vm._v(" "),
                _c("div", { staticClass: "text_w" }, [
                  _vm._v(
                    _vm._s(
                      _vm.item.industryDetailName
                        ? _vm.item.industryDetailName
                        : "---"
                    )
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "sourse" }, [
                _c("img", {
                  attrs: { src: require("../assets/img/image/list4.png") },
                }),
                _vm._v(" "),
                _c("div", { staticClass: "text_w" }, [
                  _vm._v(_vm._s(_vm.item.majorId ? _vm.item.majorId : "---")),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "line2" }),
              _vm._v(" "),
              _c("div", { staticClass: "sourse" }, [
                _c("img", {
                  attrs: { src: require("../assets/img/image/list5.png") },
                }),
                _vm._v(" "),
                _c("div", { staticClass: "text" }, [
                  _vm._v("来源: " + _vm._s(_vm.item.origin)),
                ]),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.type == 2
          ? _c("div", [
              _c("div", { staticClass: "text2" }, [
                _c("div", { staticClass: "name" }, [
                  _c("img", {
                    attrs: { src: require("../assets/img/icon-period.png") },
                  }),
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm._f("date")(_vm.item.createTime)) +
                      "\n        "
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "line2" }),
              _vm._v(" "),
              _c("div", { staticClass: "text2" }, [
                _c("div", { staticClass: "name" }, [
                  _c("img", {
                    attrs: { src: require("../assets/img/icon-teacher.png") },
                  }),
                  _vm._v(
                    "\n          " + _vm._s(_vm.item.hostTeacher) + "\n        "
                  ),
                ]),
                _vm._v(" "),
                _vm.item.studentNumber
                  ? _c("div", { staticClass: "name name2" }, [
                      _c("img", {
                        attrs: { src: require("../assets/img/icon-see.png") },
                      }),
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.item.studentNumber) +
                          "人\n        "
                      ),
                    ])
                  : _vm._e(),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.type == 3
          ? _c("div", [
              _c("div", { staticClass: "text2" }, [
                _c("div", { staticClass: "name" }, [
                  _c("img", {
                    attrs: { src: require("../assets/img/icon-teacher.png") },
                  }),
                  _vm._v(
                    "\n          " + _vm._s(_vm.item.hostTeacher) + "\n        "
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "line2" }),
              _vm._v(" "),
              _c("div", { staticClass: "text2" }, [
                _c("div", { staticClass: "name" }, [
                  _c("img", {
                    attrs: { src: require("../assets/img/icon-origin.png") },
                  }),
                  _vm._v(
                    "\n          来源：" +
                      _vm._s(_vm.item.courseSource) +
                      "\n        "
                  ),
                ]),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.type == 4 || _vm.type == 6
          ? _c("div", [
              _c("div", { staticClass: "text2" }, [
                _c("div", { staticClass: "name" }, [
                  _c("img", {
                    attrs: { src: require("../assets/img/icon-teacher.png") },
                  }),
                  _vm._v(
                    "\n          " + _vm._s(_vm.item.hostTeacher) + "\n        "
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "name name2" }, [
                  _vm._v(
                    "\n          " + _vm._s(_vm.item.majorCatId) + "\n        "
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "line2" }),
              _vm._v(" "),
              _c("div", { staticClass: "text2" }, [
                _c("div", { staticClass: "name" }, [
                  _c("img", {
                    attrs: { src: require("../assets/img/icon-origin.png") },
                  }),
                  _vm._v(
                    "\n          来源：" +
                      _vm._s(_vm.item.courseSource) +
                      "\n        "
                  ),
                ]),
                _vm._v(" "),
                _vm.type == 4 && _vm.item.studentNumber
                  ? _c("div", { staticClass: "name name2" }, [
                      _c("img", {
                        attrs: { src: require("../assets/img/icon-see.png") },
                      }),
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.item.studentNumber) +
                          "人\n        "
                      ),
                    ])
                  : _vm._e(),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.type == 5
          ? _c("div", [
              _c("div", { staticClass: "text2" }, [
                _c("div", { staticClass: "name" }, [
                  _c("img", {
                    attrs: { src: require("../assets/img/icon-origin.png") },
                  }),
                  _vm._v(
                    "\n          来源：" +
                      _vm._s(_vm.item.courseSource) +
                      "\n        "
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "line2" }),
              _vm._v(" "),
              _c("div", { staticClass: "text2" }, [
                _c("div", { staticClass: "name" }, [
                  _c("img", {
                    attrs: { src: require("../assets/img/icon-teacher.png") },
                  }),
                  _vm._v(
                    "\n          " + _vm._s(_vm.item.hostTeacher) + "\n        "
                  ),
                ]),
                _vm._v(" "),
                _vm.item.studentNumber
                  ? _c("div", { staticClass: "name name2" }, [
                      _c("img", {
                        attrs: { src: require("../assets/img/icon-see.png") },
                      }),
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.item.studentNumber) +
                          "人\n        "
                      ),
                    ])
                  : _vm._e(),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.type == 7
          ? _c("div", [
              _c("div", { staticClass: "line2" }),
              _vm._v(" "),
              _c("div", { staticClass: "text2" }, [
                _c("div", { staticClass: "name" }, [
                  _c("img", {
                    attrs: { src: require("../assets/img/icon-teacher.png") },
                  }),
                  _vm._v(
                    "\n          " + _vm._s(_vm.item.hostTeacher) + "\n        "
                  ),
                ]),
                _vm._v(" "),
                _vm.item.studentNumber
                  ? _c("div", { staticClass: "name name2" }, [
                      _c("img", {
                        attrs: { src: require("../assets/img/icon-see.png") },
                      }),
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.item.studentNumber) +
                          "人\n        "
                      ),
                    ])
                  : _vm._e(),
              ]),
            ])
          : _vm._e(),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }